/// <amd-module name="Build/Admin/Common/Components/NotificationArea" />
import * as React from "react";

import { MessageCard, MessageCardSeverity  } from "VSSUI/MessageCard";

import { INotification, NotificationType } from "Build/Admin/Common/Stores/NotificationStore";

export interface INotificationAreaProps {
    notifications: INotification[];
    onNotificationDismissed(notification: INotification): void;
}

const mapToMessageCardType: { [key: number]: MessageCardSeverity  } = {
    [NotificationType.info]: MessageCardSeverity.Info,
    [NotificationType.warning]: MessageCardSeverity.Warning,
    [NotificationType.error]: MessageCardSeverity.Error,
};

export class NotificationArea extends React.Component<INotificationAreaProps> {
    public render(): JSX.Element {
        return (
            <div aria-live="assertive">
                {
                    this.props.notifications.map((notification: INotification, index: number) => {
                        return (
                            <div key={index} className="page-content-top page-content-left page-content-right">
                                <MessageCard
                                    severity={mapToMessageCardType[notification.notificationType]}
                                    buttonProps={notification.buttonProps}
                                    onDismiss={() => this.props.onNotificationDismissed(notification)}>
                                        {notification.message}
                                </MessageCard>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}
